// Product gallery: the stage is a scroll-snap track; a thumbnail scrolls its slide into view and marks itself
// current, and the counter follows whichever slide is in view. Without JavaScript thumbnails are anchor links.
(() => {
  const gallery = document.querySelector('[data-gallery]');
  if (!gallery) return;
  const track = gallery.querySelector('[data-gallery-track]');
  const counter = gallery.querySelector('[data-gallery-counter]');
  const thumbs = [...gallery.querySelectorAll('[data-gallery-thumb]')];
  const slides = [...track.children];

  // Wall view. "View on your wall" goes into model-viewer's own AR slot, replacing its round icon: the viewer then
  // shows it only on a device that can place the print, and a tap starts AR. The model file loads lazily, when
  // the 3D slide is first shown.
  const modelSlide = track.querySelector('[data-wall-model]');
  const viewer = modelSlide?.querySelector('model-viewer');
  const arButton = modelSlide?.querySelector('[data-wall-ar]');
  if (viewer && arButton) {
    arButton.slot = 'ar-button';
    arButton.hidden = false;
    viewer.append(arButton);
  }
  let modelRequested = false;
  const loadModel = () => {
    if (modelRequested || !viewer) return;
    modelRequested = true;
    viewer.loading = 'eager';
    // Shopify normally defines <model-viewer> on its own; ask for it if it has not.
    if (!customElements.get('model-viewer')) {
      window.Shopify?.loadFeatures?.([{name: 'model-viewer-ui', version: '1.0', onLoad: () => {}}]);
    }
  };

  const setCurrent = (index) => {
    thumbs.forEach((thumb, i) => thumb.toggleAttribute('aria-current', i === index));
    // Desktop CSS shows only the slide marked active; on a phone the track scrolls.
    slides.forEach((slide, i) => slide.toggleAttribute('data-active', i === index));
    slides[index]?.setAttribute('data-active', 'true');
    if (counter) counter.textContent = `${index + 1} / ${slides.length}`;
    if (slides[index] === modelSlide) loadModel();
  };

  thumbs.forEach((thumb) => thumb.addEventListener('click', (event) => {
    event.preventDefault();
    const index = Number(thumb.dataset.galleryThumb);
    slides[index]?.scrollIntoView({behavior: 'auto', block: 'nearest', inline: 'start'});
    setCurrent(index);
  }));

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting && entry.intersectionRatio > 0.6) setCurrent(slides.indexOf(entry.target));
    });
  }, {root: track, threshold: [0.6]});
  slides.forEach((slide) => observer.observe(slide));

  // Full-size view: a photo opens in the lightbox dialog at 2048px. The close button, Escape (native to <dialog>)
  // or a click anywhere outside the photo closes it; left and right arrows step through the photos.
  const lightbox = document.querySelector('[data-lightbox]');
  const zoomButtons = [...gallery.querySelectorAll('[data-zoom-src]')];
  if (lightbox && typeof lightbox.showModal === 'function' && zoomButtons.length) {
    const zoomImage = lightbox.querySelector('[data-lightbox-img]');
    const closeButton = lightbox.querySelector('[data-lightbox-close]');
    let shown = 0;
    const showPhoto = (index) => {
      shown = (index + zoomButtons.length) % zoomButtons.length;
      zoomImage.src = zoomButtons[shown].dataset.zoomSrc;
      zoomImage.alt = zoomButtons[shown].querySelector('img')?.alt || '';
      // Keep the intrinsic size in the photo's own proportions so the reserved box matches it.
      const ratio = Number(zoomButtons[shown].dataset.zoomRatio) || 1;
      zoomImage.width = 2048;
      zoomImage.height = Math.round(2048 / ratio);
    };
    zoomButtons.forEach((button, index) => button.addEventListener('click', () => {
      showPhoto(index);
      lightbox.showModal();
      closeButton.focus();
    }));
    closeButton.addEventListener('click', () => lightbox.close());
    // The photo ignores pointer events, so any click that is not the close button lands on the dialog itself.
    lightbox.addEventListener('click', (event) => {
      if (event.target === lightbox) lightbox.close();
    });
    lightbox.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') showPhoto(shown + 1);
      if (event.key === 'ArrowLeft') showPhoto(shown - 1);
    });
  }

  // Recently viewed: this browser's last few product pages, newest first, as tiles. The list lives in localStorage
  // only; the row stays hidden when there is nothing else to show.
  const recent = document.querySelector('[data-recent]');
  if (recent) {
    const key = 'lunthra:recent';
    const current = recent.dataset.handle;
    let seen = [];
    try { seen = JSON.parse(localStorage.getItem(key) || '[]'); } catch { seen = []; }
    if (!Array.isArray(seen)) seen = [];
    const others = seen.filter((handle) => handle !== current).slice(0, 3);
    try { localStorage.setItem(key, JSON.stringify([current, ...others].slice(0, 8))); } catch { /* storage blocked */ }
    if (others.length) {
      const grid = recent.querySelector('[data-recent-grid]');
      Promise.all(others.map(async (handle) => {
        try {
          const response = await fetch(`/products/${encodeURIComponent(handle)}?view=recent`);
          return response.ok ? await response.text() : '';
        } catch { return ''; }
      })).then((tiles) => {
        const html = tiles.filter(Boolean).join('');
        if (!html) return;
        grid.innerHTML = html;
        recent.hidden = false;
      });
    }
  }

  // "Size guide" opens the size accordion further down and scrolls to it.
  document.querySelector('[data-open-size-guide]')?.addEventListener('click', () => {
    const details = document.getElementById('size-guide');
    if (details) details.open = true;
  });
})();
